import React from 'react';
import { Select } from 'antd';

const SelectServiceInvoiceIbsCbsOperationType = ({ ...rest }) => {
  return (
    <Select {...rest} allowClear>
      <Select.Option value="supplyWithSubsequentPayment">
        Fornecimento com pagamento posterior
      </Select.Option>
      <Select.Option value="paymentReceivedAfterSupply">
        Recebimento do pagamento com fornecimento já realizado
      </Select.Option>
      <Select.Option value="supplyWithPriorPayment">
        Fornecimento com pagamento já realizado
      </Select.Option>
      <Select.Option value="paymentReceivedBeforeSupply">
        Recebimento do pagamento com fornecimento posterior
      </Select.Option>
      <Select.Option value="simultaneousSupplyAndPayment">
        Fornecimento e recebimento do pagamento concomitantes
      </Select.Option>
    </Select>
  );
};

export default SelectServiceInvoiceIbsCbsOperationType;
